const MEDIA_ITEMS = [
  {
    title: '暑期档热门大片合集',
    desc: '院线新片陆续登陆，动作科幻喜剧一网打尽，高清画质流畅在线看',
    img: 'https://readdy.ai/api/search-image?query=Epic%20action%20movie%20scene%20with%20cinematic%20lighting%20and%20dramatic%20composition%2C%20hero%20silhouette%20against%20warm%20sunset%20sky%2C%20film%20grain%20texture%2C%20artistic%20movie%20poster%20style%2C%20rich%20amber%20and%20deep%20brown%20tones%2C%20professional%20cinematography%20aesthetic&width=800&height=450&seq=media-card-01&orientation=landscape',
    tag: '热门动作',
  },
  {
    title: '高分国产剧推荐',
    desc: '豆瓣8分以上优质国产剧，悬疑爱情古装全类型覆盖，口碑佳作不容错过',
    img: 'https://readdy.ai/api/search-image?query=Chinese%20period%20drama%20scene%20with%20elegant%20traditional%20costumes%2C%20warm%20lantern%20light%2C%20atmospheric%20palace%20interior%2C%20soft%20cinematic%20lighting%2C%20artistic%20composition%2C%20rich%20vermilion%20and%20gold%20accents%2C%20film%20poster%20aesthetic&width=800&height=450&seq=media-card-02&orientation=landscape',
    tag: '国产口碑',
  },
  {
    title: '海外热剧同步追',
    desc: '美剧韩剧日剧持续更新，字幕同步上线，追剧不落伍，第一时间看新番',
    img: 'https://readdy.ai/api/search-image?query=International%20TV%20series%20collage%20with%20diverse%20actors%20in%20dramatic%20scenes%2C%20warm%20cinematic%20color%20grading%2C%20film%20poster%20aesthetic%2C%20professional%20lighting%2C%20rich%20amber%20and%20cream%20tones%2C%20artistic%20movie%20promotional%20style&width=800&height=450&seq=media-card-03&orientation=landscape',
    tag: '海外热剧',
  },
];

export default function MediaSection() {
  return (
    <section id="media" className="w-full px-4 md:px-6 py-16 md:py-20 bg-background-50">
      <div className="max-w-[1280px] mx-auto">
        <div className="text-center mb-10">
          <span className="inline-block px-3 py-1 text-xs font-medium bg-accent-100 text-accent-700 rounded-full mb-3 whitespace-nowrap">
            精彩推荐
          </span>
          <h2 className="text-2xl md:text-3xl font-bold text-foreground-900 font-heading">
            热播影视精选
          </h2>
          <p className="text-sm text-foreground-500 mt-2">
            每日精选高分好片，让您不再剧荒
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {MEDIA_ITEMS.map((item, i) => (
            <article
              key={i}
              className="group bg-background-50 rounded-xl overflow-hidden border border-background-200/70 hover:border-primary-200 transition-all cursor-pointer"
            >
              <div className="relative aspect-video overflow-hidden">
                <img
                  src={item.img}
                  alt={item.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/50 via-transparent to-transparent"></div>
                <div className="absolute top-3 left-3">
                  <span className="px-2.5 py-1 text-xs font-medium bg-accent-500 text-background-50 rounded-full whitespace-nowrap">
                    {item.tag}
                  </span>
                </div>
                <div className="absolute bottom-3 right-3 w-10 h-10 flex items-center justify-center rounded-full bg-primary-500/80 text-background-50 group-hover:bg-primary-500 transition-colors">
                  <i className="ri-play-fill text-lg"></i>
                </div>
              </div>
              <div className="p-5">
                <h3 className="text-base font-bold text-foreground-900 font-heading mb-2 group-hover:text-primary-600 transition-colors">
                  {item.title}
                </h3>
                <p className="text-sm text-foreground-500 leading-relaxed">
                  {item.desc}
                </p>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}